import React from 'react';
import { Menu, Typography } from 'antd';
import { Link } from 'react-router-dom';
import history from '../../../../redux/history';
import { useDispatch } from 'react-redux';
import { changeTitle } from '../../../../redux/actions/app';
import { SettingOutlined } from '@ant-design/icons';
import { TitleAction } from '../../shared-components/TitleAction';
import * as ROUTES from '../../../../routes';
import styles from '../LeftMenuSidebar/left-menu-sidebar.module.sass';

export function PreferencesSubMenu(props) {
  const dispatch = useDispatch();
  const { Title, Text } = Typography;
  const { isKeyOn, setSessionStorage, toggleKey, ...rest } = props;

  return (
    <Menu.SubMenu
      data-cy={`preferencesSubMenuPreferences`}
      title={
        <TitleAction
          menuKey={'preferences'}
          title={
            <div className={styles.section_title}>
              <div className={styles.border} />
              <SettingOutlined />
              <Title level={5}>Preferences</Title>
            </div>
          }
          showDownArrow={props.isKeyOn('preferences')}
        />
      }
      className={styles.main_menu_option}
      {...rest}
    >
      <Menu.Item
        data-cy={`preferencesSubMenuOrganizationAssets`}
        onClick={() => {
          props.setSessionStorage('organization-assets-menu-item');
          dispatch(changeTitle('Organization Assets', null));
          history.push(ROUTES.INDICATORS);
        }}
        key="organization-assets-menu-item"
        disabled={!props.mySubscriptionPlan?.has_access_to_threat_ranking}
      >
        <Link to="/indicators">
          <Text className={styles.additional_indentation} strong>
            Organization Assets
          </Text>
        </Link>
      </Menu.Item>
    </Menu.SubMenu>
  );
}
